import { useEffect } from "react";
import { useSelector } from "react-redux";
import AutoRefreshUsers from "../../../components/SettingModuleComponent/UserPageComponent/AutoRefreshUsers";
import CreateUsersModal from "../../../components/SettingModuleComponent/UserPageComponent/CreateUsersModal";
import DeleteUsersModal from "../../../components/SettingModuleComponent/UserPageComponent/DeleteUsersModal";
import OrganizationModal from "../../../components/SettingModuleComponent/UserPageComponent/OrganizationModal";
import UsersTableColumn from "../../../components/SettingModuleComponent/UserPageComponent/UsersTableColumn";
import TableComponent from "../../../components/SharedComponent/TableComponent/TableComponent";
import { closeCreateUsersModal, closeDeleteUsersModal, closeOrganizationModal, fetchPaginateUsers, fetchUsers, openCreateUsersModal, openDeleteUsersModal, openOrganizationModal, resetUsersTable, updateUsersRequestBody } from "../../../redux/SettingModule/UsersPage/UsersAction";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function UsersPage() {
  const dispatch = useAppDispatch();
  const usersPageState = useSelector((state: RootState) => state.UsersPageState);

  //Modal
  const createUsersModalState = useSelector((state: RootState) => state.UsersPageState.createUsersModalState);

  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }

      return false;
    };

    const newSortingRequestBody = {
      ...usersPageState.currentRequestBody,
      SortColumn: sorter.field,
      IsAsc: isAscend(sorter.order),
    };

    dispatch(resetUsersTable());
    dispatch(updateUsersRequestBody(newSortingRequestBody));
    dispatch(fetchUsers({}));
  };
  useEffect(() => {
    dispatch(fetchUsers({}));
    return () => {
      dispatch(resetUsersTable());
    };
  }, []);
  return (
    <div className="body-container gap-3">
      <AutoRefreshUsers />
      <TableComponent
        columns={UsersTableColumn}
        dataSource={usersPageState.data}
        pagination={usersPageState.pagination}
        handleTableSorting={handleTableSorting}
        fetchPaginatedData={() => fetchPaginateUsers({})}
        loading={usersPageState.loading}
        tableKey={"Users"}
      />
      <DeleteUsersModal
        openState={usersPageState.deleteUsersModalState}
        open={() => dispatch(openDeleteUsersModal())}
        close={() => dispatch(closeDeleteUsersModal())}
      />
      <CreateUsersModal
        openState={createUsersModalState}
        open={() => dispatch(openCreateUsersModal())}
        close={() => dispatch(closeCreateUsersModal())}
      />
      <OrganizationModal
        openState={usersPageState.organizationModalState}
        close={() => dispatch(closeOrganizationModal())}
        open={() => dispatch(openOrganizationModal())}
      />
    </div>
  );
}

export default UsersPage;
